module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAE0lEQVR4XmP4//8/AzrGEKCCIAB4w0q2ZkqJLQAAAABJRU5ErkJggg=="